module.exports = __webpack_public_path__ + "media/images/demo_tests/pincode-632bc196a06c045dd70d98a9f72c905d.gif";